import React, { useState } from "react";
import CodeBlock from "../../components/CodeBlock";
import "./styles.scss";
import { useLanguage } from "../../contexts/LanguageContext";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { DataInit, code } from "./data";
import { Tag } from "primereact/tag";

const Authentication: React.FC = () => {
  const [data] = useState<DataInit[]>(code);
  const { selectedLanguage, getCodeSnippet } = useLanguage();
  const signatureCode = getCodeSnippet("auth", "signatureCode");
  const requestProcess = getCodeSnippet("auth", "requestProcess");

  const statusBodyTemplate = (rowData: DataInit) => {
    return (
      <Tag
        value={rowData.required ? "TRUE" : "OPTIONAL"}
        severity={rowData.required ? "danger" : "warning"}
      />
    );
  };

  return (
    <>
      <div className="px-0 py-4 md:px-4">
        <div className="main-div">
          <p className="text-6xl m-0 mb-4">Authentication</p>
          <p className="m-0 text-xl mb-4">
            Token is a certificate issued by the server to identify the user's
            identity or access rights after the user has passed the
            authentication. It can reduce repeated authentication, control
            resource access by carrying permission information, and ensure the
            security of the request. Authentication is the process of confirming
            the user's identity, and token is the result of successful
            authentication, which is used for subsequent authorization and
            resource access. Tokens are widely used in modern Web and API
            systems because of their stateless characteristics.
          </p>

          <h2>Request Field Required</h2>

          <DataTable
            value={data}
            showGridlines
            tableStyle={{ minWidth: "50rem" }}
            className="mb-4"
          >
            <Column field="name" header="Name" />
            <Column field="type" header="Type" />
            <Column
              field="required"
              header="Required"
              body={statusBodyTemplate}
            />
            <Column field="description" header="Description" />
          </DataTable>

          <h2>Code Encryption Process</h2>
          <CodeBlock code={signatureCode} language={selectedLanguage} />

          <h2 className="mt-5">Request API Format</h2>
          <CodeBlock code={requestProcess} language={selectedLanguage} />

          <p className="m-0 text-xl mt-4">
            Whenever you request from our server, you should follow the above
            format. This format is to ensure that your request is secure, and
            our server will accept your request and verify it.
          </p>

          <div className="flex justify-content-between flex-wrap mt-5">
            <div className="flex align-items-center justify-content-center">
              <a
                href="/introduction"
                className="p-button p-component p-button-info flex align-items-center no-underline"
                title="Whatsup2u Introduction"
              >
                <i className="bi bi-arrow-left p-button-icon-left"></i>
                <span className="p-button-label">Dashboard</span>
              </a>
            </div>
            <div className="flex align-items-center justify-content-center">
              <a
                href="/errors"
                className="p-button p-component p-button-info flex align-items-center no-underline"
                title="Whatsup2u Errors"
              >
                <span className="p-button-label">Errors</span>
                <i className="bi bi-arrow-right p-button-icon-right"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Authentication;
